export default __webpack_public_path__ + "static/media/ThumbsUpIcon.0abc1331.svg";